module.exports = __webpack_public_path__ + "media/images/shared/about_live/talkport/sample_talk-55c65232a83202fd4e2f22d046280e43.png";